import axios from '@/libs/api.request'

// 企业审核管理
export const getCompanyAuditList = (params) => {
  return axios.request({
    url: '/v1/account/companyaudit/list',
    method: 'get',
    params
  })
}

export const getCompanyAuditDetail = (params) => {
  return axios.request({
    url: '/v1/account/companyaudit/detail',
    method: 'get',
    params
  })
}

export const companyAuditAction = (data) => {
  return axios.request({
    url: '/v1/account/companyaudit/action',
    method: 'post',
    data
  })
}